import { mt,type MarketKey } from '../lib/i18n'
import Icon from '../components/Icon'

/** Trust coconuts and the fun level they unlock. Shown on profiles and on My items. */
export default function Coconuts({coconuts,levelKey,next,mine}:{coconuts:number;levelKey:string;next:number|null;mine?:boolean}){
 const name=mt(`cocoLevel_${levelKey}` as MarketKey)
 return <div className="coco-card" aria-label={`${mt('coconuts')}: ${coconuts}`}>
  <span className={`coco-medal level-${levelKey}`} aria-hidden="true"><Icon name="coconut" size={30}/></span>
  <div><div className="coco-count"><strong>{coconuts}</strong> <span>{mt('coconuts')}</span></div><div className="coco-level">{name}</div>
  <div className="coco-sub">{next!==null?mt('cocoNext').replace('{n}',String(next-coconuts)):mt('cocoTop')}{mine&&coconuts===0?` · ${mt('cocoStart')}`:''}</div></div>
 </div>
}
